import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { logoutUser } from "../../../Redux/Auth/AuthActions";
import { AppDispatch } from "../../../Redux/store";
import { RootState } from "../../../Redux/store";
import Logo from "../../../Assets/Logo.png";
import { FaRegBell } from "react-icons/fa";
import styles from "./Header.module.scss";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router";
function Header() {
  const { user, token } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className={styles.mainContainer}>
      <Link to="/" className={styles.logoContainer}>
        <img src={Logo} alt="logo" className={styles.logo} />
      </Link>
      {!user && !token && (
        <div className={styles.menuContainer}>
          <a href="mailto:info@amenigies.com">
            <button className={styles.loginButton}>Contact US</button>
          </a>
          <Link className={styles.loginButton} to="/login" replace>
            Login
          </Link>
        </div>
      )}
      {user && token && (
        <div className={styles.menuContainer}>
          <div className={styles.notificationContainer}>
            <FaRegBell className={styles.icon} />
          </div>

          <Menu
            menuButton={
              <MenuButton>
                <div className={styles.menuItem}>
                  {user && (
                    <p>
                      {user?.member?.firstName?.[0] +
                        user?.member?.lastName?.[0]}
                    </p>
                  )}
                </div>
              </MenuButton>
            }
            transition
          >
            <MenuItem onClick={() => dispatch(logoutUser())}>Logout</MenuItem>
          </Menu>
        </div>
      )}
    </div>
  );
}

export default Header;
